import { withTranslation } from "react-i18next"
import React, { Fragment, useEffect, useState } from "react"
import { Card, CardBody, CardFooter, Col, Row } from "reactstrap"

const Header = ({ data, t }) => {
  const [dataHeader, setDataHeader] = useState([])

  useEffect(() => {
    if (data) {
      setDataHeader(data)
    }
  }, [data])

  return (
    <Fragment>
      <Row style={{ paddingTop: 0 }}>
        {dataHeader.map((item, index) => (
          <Col key={index} xl={3} lg={3} md={3} sm={12}>
            <Card
              className="mini-stats-wid mb-2"
              style={{ overflow: "hidden", height: '80px' }}
            >
              <CardBody style={{ paddingTop: '10px' }}>
                <div className="d-flex">
                  <div className="flex-grow-1">
                    <p
                      className="text-muted fw-medium"
                      style={{
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        fontSize: 14,
                      }}
                    >
                      {t(`generalDashboard:${item.label}`)}
                    </p>
                    <h4 className="mb-0" style={{ fontSize: 22 }}>
                      {item.total}
                    </h4>
                  </div>

                  {/* <div className="flex-shrink-0 align-self-center">
                    <WidgetChart
                      dataColors={[
                        `--bs-${item.type == 1 ? "success" : "danger"}`,
                        "--bs-transparent",
                      ]}
                      series={item.seriesData}
                      dir="ltr"
                    />
                  </div> */}
                  {/* <div className="" > */}
                  <div className="mb-0" style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-around', alignItems: 'end' }}>
                    <div
                      className={`badge badge-soft-${item.isIncrease ? "success" : "danger"
                        } `}
                      style={{ fontSize: '12px', width: 'fit-content' }}
                    >
                      <i
                        className={`bx bx-trending-${item.isIncrease ? "up" : "down"
                          } align-bottom me-1`}
                      ></i>{" "}
                      {item.percentage}
                    </div>
                    {/* <span>
                      {item.isIncrease
                        ? "Increase last month"
                        : "Decrease last month"}
                    </span> */}
                  </div>
                  {/* </div> */}
                </div>
              </CardBody>

            </Card>
          </Col>
        ))}
      </Row>
    </Fragment>
  )
}

export default withTranslation(["generalDashboard", "common"])(Header)
